import { Boundaries } from "@planzone/core";
import { Identifiable, Milestone } from "@planzone/dto";

function handleRemoveTagRequest(
  milestone: Identifiable<Milestone>,
  { removableId, tag }: Boundaries["removeTag"]["request"],
): Identifiable<Milestone> {
  return milestone.uuid === removableId
    ? {
        ...milestone,
        tags: milestone.tags.filter(({ name }) => name !== tag.name),
      }
    : milestone;
}

function handleRemoveTagSuccess(
  milestone: Identifiable<Milestone>,
  { removableId, tag }: Boundaries["removeTag"]["success"],
): Identifiable<Milestone> {
  return milestone.uuid === removableId
    ? {
        ...milestone,
        tags: milestone.tags.filter(({ name }) => name !== tag.name),
      }
    : milestone;
}

function handleRemoveTagFailure(
  milestone: Identifiable<Milestone>,
  { removableId, tag }: Boundaries["removeTag"]["failure"],
): Identifiable<Milestone> {
  return milestone.uuid === removableId
    ? {
        ...milestone,
        tags: milestone.tags ? [...milestone.tags, tag] : [tag],
      }
    : milestone;
}

export {
  handleRemoveTagRequest,
  handleRemoveTagSuccess,
  handleRemoveTagFailure,
};
